/**
 * Header pinning a custom client request to the deployment that served the bundle, so Vercel
 * Skew Protection routes it there instead of the newest deployment. Empty outside Vercel or
 * when skew protection is disabled. Both vars are inlined at build time via `next.config.ts` `env`.
 * Import from `@/config/deployment` directly: the `@/config` barrel pulls in `client-envs`
 * validation, which fails in unit tests.
 */
export function getDeploymentHeaders(): Record<string, string> {
  const deploymentId = process.env.VERCEL_DEPLOYMENT_ID
  if (process.env.VERCEL_SKEW_PROTECTION_ENABLED !== '1' || !deploymentId) return {}
  return { 'x-deployment-id': deploymentId }
}

/** Same pinning as `getDeploymentHeaders`, for requests that cannot carry headers (e.g. `sendBeacon`). */
export function withDeploymentParam(url: string): string {
  const deploymentId = getDeploymentHeaders()['x-deployment-id']
  if (!deploymentId) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}dpl=${encodeURIComponent(deploymentId)}`
}
